"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _black = _interopRequireDefault(require("../tokens/color/black"));
var _noop2 = _interopRequireDefault(require("lodash-es/noop"));
var _commonHelper = require("../helpers/commonHelper");
var _propTypes = _interopRequireDefault(require("prop-types"));
var SVG = /*#__PURE__*/_styledComponents["default"].svg.withConfig({
  componentId: "sc-rbbb40-0"
})(["", ""], _commonHelper.svgStyle);
var Icon = function Icon(props) {
  var color = props.color,
    baseColor = props.baseColor,
    size = props.size,
    showPointer = props.showPointer,
    onClick = props.onClick,
    className = props.className,
    children = props.children,
    iconName = props.iconName,
    percentage = props.percentage,
    uniqueId = props.uniqueId;
  var titleId = "icon-svg-title-".concat(iconName);
  var descId = "icon-svg-desc-".concat(iconName);
  return /*#__PURE__*/_react["default"].createElement(Icon.Element, (0, _extends2["default"])({
    showPointer: showPointer,
    onClick: onClick,
    className: className
  }, props), /*#__PURE__*/_react["default"].createElement(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: color,
    width: size,
    height: size,
    viewBox: "0 0 20 20" // don't change this
    ,
    "aria-labelledby": "".concat(titleId, " ").concat(descId),
    role: "img"
  }, !!percentage && /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: uniqueId,
    x1: "0",
    x2: "100%",
    y1: "0",
    y2: "0"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0",
    stopColor: color
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "".concat(percentage, "%"),
    stopColor: color
  }), percentage < 100 && /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "".concat(percentage + 1, "%"),
    stopColor: baseColor
  }), percentage < 100 && /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "1",
    stopColor: baseColor
  })), children));
};
Icon.Element = _styledComponents["default"].i.withConfig({
  componentId: "sc-rbbb40-1"
})(["", ""], _commonHelper.iconStyle);
Icon.defaultProps = {
  color: _black["default"],
  baseColor: "transparent",
  size: 20,
  showPointer: false,
  onClick: _noop2["default"],
  className: "",
  children: null,
  iconName: "",
  percentage: 0
};
Icon.propTypes = {
  /** The color prop helps user to set a custom color of the icon. */
  color: _propTypes["default"].string,
  /** Size prop overrides the default size of the icon. It helps user to set a custom size of the icon. */
  size: _propTypes["default"].number,
  /** Callback function to be triggered when user clicks on an icon. */
  onClick: _propTypes["default"].func,
  /**  Shows cursor as pointer on hover if set to true. By default it does not show pointer; */
  showPointer: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  iconName: _propTypes["default"].string,
  children: _propTypes["default"].node,
  uniqueId: _propTypes["default"].string.isRequired,
  baseColor: _propTypes["default"].string,
  percentage: _propTypes["default"].number
};
var _default = exports["default"] = Icon;